import { render, staticRenderFns } from "./tappay-form.vue?vue&type=template&id=26e68e20&lang=pug&"
import script from "./tappay-form.vue?vue&type=script&lang=js&"
export * from "./tappay-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports